<template>
    <div class="container-diario">

        <c-panel>
            
            <el-form label-position="top" class="u-mb-20">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" v-if="([4, 5, 6, 7, 8, 10, 11].includes(Number($store.state.user.tipo)))">
                        <el-form-item key="instituicao">
                            <el-select @change="loadingTurmas" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição">
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item key="periodo">
                            <el-select @change="loadingTurmas" v-model="filtro.periodo_id">
                                <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="20" :md="20">
                        <el-form-item key="instituicao">
                            <el-select @change="loadingAlunos" v-model="filtro.turma_id" filterable placeholder="Turma">
                                <el-option-group
                                    v-for="(grupo, i) in turmas"
                                    :key="i"
                                    label="">
                                <el-option
                                    v-for="turma in grupo"
                                    :key="turma.id"
                                    :label="`${turma.curso.nome} ${turma.nome}`"
                                    :value="turma.id">
                                </el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    
                </el-row>
            </el-form>
            <div class="u-mb-10" v-if="filtro.turma_id">
                <i>Atenção: É possível alterar a data de matrícula e transferência clicando sobre a data.</i>
                <el-button v-if="filtro.turma_id" @click="openDialogConteudo(filtro.turma_id)" title="Mais ações" size="mini" style="float: right; width: 120px;" plain>
                    <i class="fas fa-edit"></i>
                    Conteúdo
                </el-button>
            </div>
            <div class="" v-if="filtro.turma_id">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 90px;">Nº Matrícula</th>
                            <th>Nome</th>
                            <th class="u-text-center">Data Matrícula</th>
                            <th class="u-text-center">Data Transferência</th>
                            <th style="width: 300px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading">
                        <tr v-for="item in alunos" :key="item.id">
                            <td>{{ item.aluno.num_matricula }}</td>
                            <td>
                                <a @click="openDossieAluno(item)" title="Abrir dossiê do aluno" href="javascript:void(0)">
                                    <b class="hidden-desktop">NOME:</b> {{ item.aluno.nome_social_aluno ? item.aluno.nome + ' – ' + item.aluno.nome_social_aluno : item.aluno.nome }}<br>
                                </a>
                                <span v-if="item.aluno.mae" class="nm-mae">Filiação 1: {{ item.aluno.mae.toLowerCase() }}</span>
                            </td>
                            <td class="u-text-center">
                                <a href="javascript:void(0)" @click="abreAlteraData(item, 'matricula')">
                                    {{ item.data_matricula ? $moment(item.data_matricula).format('DD/MM/YYYY') : '---' }}
                                </a>
                           </td>
                            <td class="u-text-center">
                                <a href="javascript:void(0)" @click="abreAlteraData(item, 'transferencia')">
                                    {{ item.data_transferencia ? $moment(item.data_transferencia).format('DD/MM/YYYY') : '---' }}
                                </a>
                            </td>
                            <td class="u-text-center acao"> 
                                <el-button @click="openDialogFrequencia(item)" title="Mais ações" size="mini" style="width: 120px;" plain>
                                    <i class="far fa-calendar-alt"></i>
                                    Frequência
                                </el-button>
                                <el-button @click="openDialogNota(item.aluno)" title="Mais ações" size="mini" style="width: 120px;" plain>
                                    <i class="fas fa-calculator"></i>
                                    Notas
                                </el-button>                            
                            </td>
                        </tr>
                    </tbody>
                </table>
                
                <div v-if="loading" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
            </div>
        </c-panel>

        <div v-if="!filtro.turma_id || alunos.length === 0" class="u-mt-15">
            <div class="u-mb-15">
                <c-panel title="Situações do Calendário / Ocorrências">
                    <el-row :gutter="15">
                        <el-col :xs="24" :sm="12" :md="12">
                            <table class="table table-striped table-bordered table-condensed u-mb-0">
                                <thead>
                                    <tr>
                                        <th>Legenda</th>
                                        <th class="u-text-center" style="width: 65px;">Sigla</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in ocorrenciasCol1" :key="'oco1-' + idx">
                                        <td>{{ item.nome }}</td>
                                        <td class="u-text-center"><b>{{ item.sigla }}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12" class="u-xs-mt-10">
                            <table class="table table-striped table-bordered table-condensed u-mb-0">
                                <thead>
                                    <tr>
                                        <th>Legenda</th>
                                        <th class="u-text-center" style="width: 65px;">Sigla</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in ocorrenciasCol2" :key="'oco2-' + idx">
                                        <td>{{ item.nome }}</td>
                                        <td class="u-text-center"><b>{{ item.sigla }}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </el-col>
                    </el-row>
                </c-panel>
            </div>

            <div class="u-mb-15">
                <c-panel title="Disciplinas / Componentes Curriculares">
                    <el-row :gutter="15">
                        <el-col :xs="24" :sm="8" :md="8">
                            <table class="table table-striped table-bordered table-condensed u-mb-0">
                                <thead>
                                    <tr>
                                        <th>Legenda</th>
                                        <th class="u-text-center" style="width: 65px;">Sigla</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in disciplinasCol1" :key="'disc1-' + idx">
                                        <td>{{ item.nome }}</td>
                                        <td class="u-text-center"><b>{{ item.sigla }}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8" class="u-xs-mt-10">
                            <table class="table table-striped table-bordered table-condensed u-mb-0">
                                <thead>
                                    <tr>
                                        <th>Legenda</th>
                                        <th class="u-text-center" style="width: 65px;">Sigla</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in disciplinasCol2" :key="'disc2-' + idx">
                                        <td>{{ item.nome }}</td>
                                        <td class="u-text-center"><b>{{ item.sigla }}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8" class="u-xs-mt-10">
                            <table class="table table-striped table-bordered table-condensed u-mb-0">
                                <thead>
                                    <tr>
                                        <th>Legenda</th>
                                        <th class="u-text-center" style="width: 65px;">Sigla</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in disciplinasCol3" :key="'disc3-' + idx">
                                        <td>{{ item.nome }}</td>
                                        <td class="u-text-center"><b>{{ item.sigla }}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </el-col>
                    </el-row>
                </c-panel>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="DOSSIÊ DO ALUNO" width="90%" top="40px" :visible.sync="dialogDossieAluno" v-on:close="closeDialogDossieAluno">
            <div v-if="dialogDossieAluno" style="margin-top: 20px;">
                <dossie-aluno :id="alunoSelected.aluno.id" v-on:changeDossie="changeDossie"></dossie-aluno>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" width="95%" top="5vh" :visible.sync="dialogFrequencia">
            <template slot="title">
                <div style="line-height: 1.2;">
                    <div style="font-size: 16px; font-weight: bold;">{{ getTituloEscolaCurso(frequenciaSelected) }}</div>
                    <div style="font-size: 16px; margin-top: 5px; color: #606266;">
                        {{ alunoSelected.nome_social_aluno ? alunoSelected.nome_social_aluno +' – '+ alunoSelected.nome : alunoSelected.nome }} - {{ $moment(alunoSelected.data_nascimento).format('DD/MM/YYYY') }}
                    </div>
                </div>
            </template>
            <div v-if="dialogFrequencia" style="margin-top: 20px;">
                <frequencia :turma_id="filtro.turma_id" :aluno_id="alunoSelected.id" :tipo_ensino="alunoSelected.tipo_ensino" :mostra_gerenciar_freq="true" @close="closeDialogFrequencia"></frequencia>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" width="95%" top="5vh" :title="alunoSelected ? `${alunoSelected.nome_social_aluno ? alunoSelected.nome_social_aluno +' – '+ alunoSelected.nome : alunoSelected.nome } - ${$moment(alunoSelected.data_nascimento).format('DD/MM/YYYY')}` : ''" :visible.sync="dialogNota">
            <div v-if="dialogNota" style="margin-top: 20px;">
                <nota :turma_id="filtro.turma_id" :aluno_id="alunoSelected.id" :mostra_gerenciar_nota="true" @close="closeDialogNota"></nota>
            </div>
        </el-dialog>
        
        <el-dialog append-to-body :close-on-click-modal="false" width="95%" top="5vh" title="Conteúdo" :visible.sync="dialogConteudo">
            <div v-if="dialogConteudo" style="margin-top: 20px;">
                <conteudo :turma_id="filtro.turma_id" @close="closeDialogConteudo"></conteudo>
            </div>
        </el-dialog>

        <el-dialog append-to-body :close-on-click-modal="false" :title="`ALTERAR DATA - ${matriculaSelected.aluno ? matriculaSelected.aluno.nome : ''}`" width="40%" :visible.sync="dialogAlterarData" v-on:close="closeDialogAlterarData">
            <div v-if="dialogAlterarData" style="margin-top: 20px;">
                
                <el-form @submit.native.prevent="onSubmitAlterarData" label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="12" :sm="24" :md="24">
                            <el-form-item :label="`Data ${alteraData.tipo == 'matricula' ? 'de Matrícula' : 'da Transferência'}`" key="data" prop="data">                
                                <el-input v-model="alteraData.data" v-mask="'##/##/####'"></el-input>
                            </el-form-item>                        
                        </el-col>                   
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </el-dialog>

    </div>
</template>
<script>

import dossieAluno from '@/components/aluno/dossie'
import frequencia from '@/components/diario/frequencia/info'
import nota from '@/components/diario/nota/info'
import conteudo from '@/components/diario/conteudo/info'

export default {
    data: () => ({
        loading: false,
        dialogAlterarData: false,
        alteraData: {
            turma_id: '',
            aluno_nome: '',
            aluno_id: '',
            data: '',
            tipo: ''
        },
        matriculaSelected: {},
        frequenciaSelected: {},
        dialogDossieAluno: false,
        dialogFrequencia: false,
        dialogNota: false,
        dialogConteudo: false,
        alunoSelected: {},
        filtro: {
            instituicao_id: '',
            periodo_id: '',
            turma_id: ''
        },
        legendasOcorrencias: [
            { nome: 'ASSEMBLEIA', sigla: 'A' },
            { nome: 'ASSEMBLEIA PERMANENTE', sigla: 'AP' },
            { nome: 'ATESTADO MÉDICO DO PROFESSOR', sigla: 'AM' },
            { nome: 'CURSO DE PRIMEIRO SOCORROS', sigla: 'PS' },
            { nome: 'DEDETIZAÇÃO', sigla: 'Dd' },
            { nome: 'DIA NÃO LETIVO', sigla: 'NL' },            
            { nome: 'DOMINGO', sigla: 'D' },
            { nome: 'ENSINO REMOTO', sigla: 'RM' },
            { nome: 'FERIADO', sigla: 'F' },
            { nome: 'GREVE', sigla: 'G' },
            { nome: 'LIBERADO POR DECRETO', sigla: 'LD' },
            { nome: 'LUTO', sigla: 'L' },
            { nome: 'OUTROS', sigla: 'OT' },
            { nome: 'PARALISACAO', sigla: 'PA' },
            { nome: 'PONTO FACULTATIVO', sigla: 'PF' },
            { nome: 'RECESSO JUNINO', sigla: 'R' },
            { nome: 'RODOVIA INTERDITADA', sigla: 'RI' },
            { nome: 'SABADO', sigla: 'S' }
        ],
        legendasDisciplinas: [
            { nome: 'AGROECOLOGIA', sigla: 'AG' },
            { nome: 'ARTE (EDUCAÇÃO ARTÍSTICA, TEATRO, DANÇA, MÚSICA, ARTES PLÁSTICAS E OUTRAS)', sigla: 'AR' },
            { nome: 'CIÊNCIAS', sigla: 'C' },
            { nome: 'EDUCAÇÃO AMBIENTAL', sigla: 'AM' },
            { nome: 'EDUCAÇÃO FÍSICA', sigla: 'EF' },
            { nome: 'EMPREENDEDORISMO', sigla: 'EP' },
            { nome: 'ENSINO RELIGIOSO', sigla: 'ER' },
            { nome: 'ESPORTE E RECREACAO', sigla: 'ES' },
            { nome: 'EXPRESSOES ARTISTICAS', sigla: 'EA' },
            { nome: 'GEOGRAFIA', sigla: 'G' },
            { nome: 'HISTÓRIA', sigla: 'H' },
            { nome: 'HISTÓRIA E CULTURA AFRO', sigla: 'CA' },
            { nome: 'JOGOS MATEMATICOS', sigla: 'JM' },
            { nome: 'LEITURA E PRODUCAO DE TEXTOS', sigla: 'PT' },
            { nome: 'LIBRAS', sigla: 'Lb' },
            { nome: 'LÍNGUA/LITERATURA ESTRANGEIRA – INGLÊS', sigla: 'LI' },
            { nome: 'LÍNGUA/LITERATURA PORTUGUESA', sigla: 'LP' },
            { nome: 'MATEMÁTICA', sigla: 'M' },
            { nome: 'MONITOR', sigla: 'MT' },            
            { nome: 'REGULAR', sigla: 'DC' },
            { nome: 'TECNICAS AGRICOLAS', sigla: 'TA' },
            { nome: 'XADREZ', sigla: 'XD' }
        ],
        turmas: [],
        alunos: [ ]
    }),
    mounted () {

        this.filtro.periodo_id = this.$store.state.config.parametros.periodo_letivo_situacao_academica;

        if(this.$store.state.config.instituicao){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
            this.loadingTurmas();
        }
    },
    methods: { 
        abreAlteraData(item, tipo) {

            if(tipo == 'matricula') {

                this.alteraData.data = item.data_matricula ? this.$moment(item.data_matricula).format('DD/MM/YYYY') : '';
            } else {
                this.alteraData.data = item.data_transferencia ? this.$moment(item.data_transferencia).format('DD/MM/YYYY') : '';
            }

            this.matriculaSelected = item;
            this.alteraData.tipo = tipo;
            this.alteraData.turma_id = this.filtro.turma_id;
            this.alteraData.aluno_id = item.aluno_id;
            this.alteraData.aluno_nome = item.nome_aluno;
            this.dialogAlterarData = true;
            
        },
        async onSubmitAlterarData() {

            if(this.alteraData.tipo == 'matricula' && !this.alteraData.data) {

                window.eventBus.$emit('alert', {msg: 'É necessário informar uma data para a matrícula.', type: 'warning'});
                return;
            }
            
            window.eventBus.$emit('loading', true);

            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/updateData`, this.alteraData, this.$store.getters.getHeaderAuth);

            if(typeof response.data.erro !== 'undefined'){

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});

            }else{

                this.dialogAlterarData = false;
                window.eventBus.$emit('loading', false);
                this.loadingAlunos();
                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
            }

        },
        closeDialogAlterarData() {

            this.matriculaSelected = {};
            this.alteraData = {
                turma_id: '',
                aluno_nome: '',
                aluno_id: '',
                data: '',
                tipo: ''
            };
        },
        openDialogConteudo(turma_id){

            this.dialogConteudo = true;
        },
        closeDialogConteudo(){
            
            this.dialogConteudo = false;
        },
        openDossieAluno(item){

            this.dialogDossieAluno = true;
            this.alunoSelected = item;

        },
        getTituloEscolaCurso(selectedItem) {
            if (!selectedItem) return '';
            const escola = (selectedItem.turma && selectedItem.turma.instituicao) ? selectedItem.turma.instituicao.nome : '';
            const curso = selectedItem.turma && selectedItem.turma.curso ? selectedItem.turma.curso.nome + ' - ' + selectedItem.turma.nome : '';
            return escola && curso ? `${escola} - ${curso}` : (escola || curso || '');
        },
        openDialogFrequencia(item){ 
            this.alunoSelected = { tipo_ensino: item.turma.tipo_ensino, ...item.aluno };
            this.frequenciaSelected = item;
            this.dialogFrequencia = true;   
        },
        closeDialogFrequencia(){
            this.dialogFrequencia = false;
            this.frequenciaSelected = {};
        },
        openDialogNota(item){
            this.alunoSelected = item;
            this.dialogNota = true;
        },        
        closeDialogNota(){
            this.dialogNota = false;
        },
        closeDialogDossieAluno(){

            this.alunoSelected = {  };
            this.dialogDossieAluno = false;
        },
        loadingTurmas(){

            this.alunos = [];
            this.filtro.turma_id = '';

            if(!this.filtro.instituicao_id || !this.filtro.periodo_id) {
                return;
            }            

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${this.filtro.instituicao_id}/${this.filtro.periodo_id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.turmas = response.data;                

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        loadingAlunos(){

            this.alunos = [];

            if(!this.filtro.turma_id) {
                return;
            }            

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/getAlunosForDiario/${this.filtro.turma_id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.alunos = response.data;                

            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        changeDossie(actions){

            if(actions.close){

                this.dialogDossieAluno = false;
            }
        },
    },

    computed: {
        ocorrenciasCol1() {
            return this.legendasOcorrencias.slice(0, 9);
        },
        ocorrenciasCol2() {
            return this.legendasOcorrencias.slice(9, 18);
        },
        disciplinasCol1() {
            return this.legendasDisciplinas.slice(0, 8);
        },
        disciplinasCol2() {
            return this.legendasDisciplinas.slice(8, 16);
        },
        disciplinasCol3() {
            return this.legendasDisciplinas.slice(16, 23);
        }
    },

    components:{ dossieAluno, frequencia, nota, conteudo }
}
</script>
<style>
    .container-diario .level {
        
        border-radius: 30px !important;
        border: 2px solid #b1b1b1;

    }
    .container-diario .info {
        
        width: 100% !important;
        text-align: center !important;
    }

    .container-diario .info img {
        max-width: 200px;
    }

    .icon-edit-data {
        color: #999999;
        margin-left: 5px;
    }

    @media (max-width: 768px) {
        .u-xs-mt-10 {
            margin-top: 10px;
        }
    }

</style>